"use strict";
/* eslint-disable no-console */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callApiWithToken = exports.callApi = exports.getFullUrl = void 0;
var camelcase_keys_1 = __importDefault(require("camelcase-keys"));
var fetch_dedupe_1 = require("fetch-dedupe");
var config_1 = __importDefault(require("../../config"));
function offlineResponse() {
    console.log('[DEBUG: API]', 'You are offline.');
    return 'You are offline';
}
function getFullUrl(endpoint) {
    if (endpoint.indexOf('https://') >= 0 || endpoint.indexOf('http://') >= 0) {
        return endpoint;
    }
    return endpoint.indexOf(config_1.default.urls.api) === -1
        ? "".concat(config_1.default.urls.api).concat(endpoint)
        : endpoint;
}
exports.getFullUrl = getFullUrl;
// Fetches an API response and normalizes the result JSON according to schema.
// This makes every API response have the same shape, regardless of how nested it was.
function callApi(endpoint, method, headers, body, camelize) {
    if (method === void 0) { method = 'GET'; }
    if (headers === void 0) { headers = {}; }
    if (body === void 0) { body = ''; }
    if (camelize === void 0) { camelize = true; }
    return __awaiter(this, void 0, void 0, function () {
        var fullUrl, params, response, contentType, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fullUrl = getFullUrl(endpoint);
                    params = {
                        method: method,
                        credentials: 'include',
                        headers: __assign({}, headers),
                    };
                    if (method === 'PATCH' ||
                        method === 'POST' ||
                        method === 'PUT' ||
                        method === 'DELETE') {
                        params.body = body;
                    }
                    console.debug('[DEBUG:API]', fullUrl, method, headers, body);
                    return [4 /*yield*/, (0, fetch_dedupe_1.fetchDedupe)(fullUrl, params)];
                case 1:
                    response = _a.sent();
                    if (response.status < 100 || response.status >= 500) {
                        throw new Error(offlineResponse());
                    }
                    if (response.status === 204) {
                        return [2 /*return*/, { response: {} }];
                    }
                    contentType = response.headers.get('content-type');
                    if (contentType && contentType.indexOf('application/json') !== -1) {
                        json = response.data;
                        if (camelize) {
                            json = (0, camelcase_keys_1.default)(json, { deep: true });
                        }
                        if (!response.ok) {
                            throw new Error(JSON.stringify(json));
                        }
                        return [2 /*return*/, {
                                response: {
                                    entities: json,
                                },
                            }];
                    }
                    // For non-JSON type responses, just return the data.
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.callApi = callApi;
function callApiWithToken(endpoint, token, method, headers, body, camelize) {
    if (method === void 0) { method = 'GET'; }
    if (headers === void 0) { headers = {}; }
    if (body === void 0) { body = ''; }
    if (camelize === void 0) { camelize = true; }
    return __awaiter(this, void 0, void 0, function () {
        var tokenHeaders;
        return __generator(this, function (_a) {
            tokenHeaders = __assign({}, headers);
            if (token) {
                tokenHeaders.Authorization = "Token ".concat(token);
            }
            return [2 /*return*/, callApi(endpoint, method, tokenHeaders, body, camelize)];
        });
    });
}
exports.callApiWithToken = callApiWithToken;
